"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LATEST_CATALOGUES_DESCRIPTION = void 0;
const LATEST_CATALOGUES_DESCRIPTION = exports.LATEST_CATALOGUES_DESCRIPTION = 'latest-catalogues-description';
